import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {WebinarHeroComponent} from '../../components/webinar-hero/webinar-hero.component';
import {
    WebinarTargetGroupComponent,
    WebinarTargetGroupLevel,
} from '../../components/webinar-target-group/webinar-target-group.component';
import {
    WebinarInstructor,
    WebinarInstructorSectionComponent,
} from '../../components/webinar-instructor-section/webinar-instructor-section.component';
import {WEBINAR_INSTRUCTOR_ANDREAS_SCHLIEFER} from '../../webinar-instructors';
import {WebinarAgendaComponent, WebinarContent} from '../../components/webinar-agenda/webinar-agenda.component';
import {getParameterByName} from '../../../../shared/lib/get-parameters-by-name';
import {FormsModule} from '@angular/forms';
import {WebinarSignupSectionComponent} from '../../components/webinar-signup-section/webinar-signup-section.component';
import {isPlatformBrowser} from '@angular/common';
import {ExpertWebinarFaqs} from "../../components/expert-webinar-faq/expert-webinar-faqs.component";

@Component({
    selector: 'power-user-dokumente-schliefer',
    standalone: true,
    imports: [
        FormsModule,
        WebinarHeroComponent,
        WebinarAgendaComponent,
        WebinarTargetGroupComponent,
        WebinarHeroComponent,
        WebinarAgendaComponent,
        WebinarTargetGroupComponent,
        WebinarInstructorSectionComponent,
        WebinarSignupSectionComponent,
        ExpertWebinarFaqs,
    ],
    templateUrl: './power-user-dokumente-schliefer.component.html',
    styleUrl: '../fachwebinare.scss',
})
export class PowerUserDokumenteSchlieferComponent implements OnInit {
    protected readonly titleService = inject(Title);
    protected readonly metaService = inject(Meta);
    protected readonly httpClient = inject(HttpClient);
    protected readonly platformId = inject(PLATFORM_ID);

    protected webinarDate: string | null = null;
    protected webinarTitle = 'Power-User: Dokumente';
    protected webinarTitleShort = 'Dokumente in aX';
    protected targetGroupLevel: WebinarTargetGroupLevel = {
        beginner: true,
        intermediate: true,
        professional: true,
    };
    protected instructors: Array<WebinarInstructor> = [WEBINAR_INSTRUCTOR_ANDREAS_SCHLIEFER];
    protected price: number = 0;
    protected duration = 1.5;
    protected maximumNumberOfParticipants = null; // 100;
    protected eventOverbooked = false;
    protected webinarContents: Array<WebinarContent> = [
        {
            title: 'Dokumentenlayout',
            description: 'Stile, Layoutgruppen, Anpassungen',
        },
        {
            title: 'Textbausteine',
            description: 'Varianten, Bedingungen und Bedingungsgruppen, eigene Bausteine',
        },
        {
            title: 'Textvorlagen',
            description: 'Zustand, Mailvorlagen, Platzhalter',
        },
        {
            title: 'Textbausteine überschreiben',
            description: 'Bausteine pro Gutachten überschreiben',
        },
        {
            title: 'Word-Export',
            description: 'Gutachten frei bearbeiten',
        },
        {
            title: 'Honorartabelle + Einbindung in die Abtretung',
            description: '',
        },
        {
            title: 'Seiten automatisch zählen',
            description: '',
        },
        {
            title: 'Muster für Dateinamen',
            description: '',
        },
    ];

    constructor() {
        this.titleService.setTitle(`${this.webinarTitleShort} | Kostenfreies Online-Webinar`);
        this.metaService.addTag({
            name: 'description',
            content: `Fachwebinar ${this.webinarTitle} Wissen für Kfz-Sachverständige - rund um autoiXpert`,
        });
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.webinarDate = atob(getParameterByName('webinarDate') ?? '');
        }
    }
}
